module.exports = __webpack_public_path__ + "img/4_revenue_builder.7d926f06.png";